import * as types from '../constants/types'

const initialState = {
  isFetching: false,
  lineitems: [],
  projectLineitems: {},
  error: "",
  pages: 1,
  offset: 0,
  limit: 10,
  sort: "",
  users: []
}

export function lineitems(state = initialState, action) {
  switch(action.type) {
    case types.LINEITEMS_COMMENCE_FETCH:
    return {
      ...state,
      isFetching: true,
      viewState: types.LINEITEMS_COMMENCE_FETCH,
    }
    case types.LINEITEMS_DID_LOAD:
    const { lineitems, meta, onSaveAssignedUser } = action.payload
    const { total } = meta;
    return {
      ...state,
      isFetching: false,
      lineitems: lineitems || [],
      total: total,
      viewState: onSaveAssignedUser ? types.USER_ASSIGNMENT_UPDATE_SUCCUSS : types.LINEITEMS_DID_LOAD,
    }
    case types.LINEITEMS_BY_PROJECTID_DID_LOAD:
    const { projectLineitems, projectId } = action.payload
    return {
      ...state,
      isFetching: false,
      projectLineitems: { ...state.projectLineitems, [projectId]: projectLineitems},
      viewState: types.LINEITEMS_BY_PROJECTID_DID_LOAD,
    }
    case types.LINEITEMS_DID_ERROR:
    return {
      ...state,
      isFetching: false,
      error: action.payload.error,
      viewState: types.LINEITEMS_DID_ERROR,
    }
    case types.LINEITEMS_RESET_ERROR:
    return {
      ...state,
      viewState: types.LINEITEMS_RESET_ERROR,
      error: ""
    }
    case types.SERVER_ERROR:
    return {
      ...state,
      viewState: types.SERVER_ERROR,
      errMessage: action.err.message
    }
    case types.LIMIT_OFFSET_SORT_SET:
    return {
      ...state,
      viewState: types.LIMIT_OFFSET_SORT_SET,
      limit: action.payload.limit,
      offset: action.payload.offset,
      sort: action.payload.sort
    }
    case types.USERS_DID_LOAD:
    const { users } = action.payload
    return {
      ...state,
      viewState: types.USERS_DID_LOAD,
      users
    }
    case types.USER_ASSIGNMENT_UPDATE_SUCCUSS:
    return {
      ...state,
      viewState: types.USER_ASSIGNMENT_UPDATE_SUCCUSS,
      isFetching: false
    }
    default:
    return state
  }
}
